const Pricestar = () => {
    return (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10 0C8.28929 6.17929 6.08857 8.29143 0 10C6.08857 11.7086 8.28929 13.8207 10 20C11.7107 13.8207 13.9114 11.7086 20 10C13.9114 8.29143 11.7107 6.17929 10 0Z" fill="white" />
        </svg>
    )
}

export default Pricestar;